import { ConfirmationDialogButtons } from './confirmation-dialog-buttons';
import { Component, Input, ElementRef, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationDialogImageType } from "./confirmation-dialog-image-type";
import { Router } from '@angular/router';
import { ConfigService } from './../../base-services/config.service';
import { config } from 'rxjs';

@Component({
    selector: 'yt-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialog{
    constructor(
        protected activeModal: NgbActiveModal,
        protected router: Router,
        protected configService: ConfigService
    ){}

    @ViewChild('noButton', { static: false }) noButton: ElementRef;
    
    @Input() Type: ConfirmationDialogImageType;
    @Input() Heading: string;
    @Input() Message: string;
    @Input() Buttons: ConfirmationDialogButtons = ConfirmationDialogButtons.Ok;

    ngAfterViewInit(){
        if(this.noButton)
            this.noButton.nativeElement.focus();
    }

    onClick(value){
        this.activeModal.close(value);
        //if(!value)
            //this.activeModal.dismiss();
    }

    onLoginClick(){
        this.activeModal.dismiss();
        this.router.navigate(['/login']);
    }

    onPricelistClick(){
        // window.location.href = 'http://yuteam.co.rs';
        //let urlCenovnik: string =this.configService.GetPricelistUrl();
        //window.location.href = urlCenovnik;
      this.configService.GetPricelistUrlAsync().subscribe(url => {
        if (url) {
          window.location.href = url;
        } else {
          console.error("Cenovnik URL nije dostupan.");
        }
      });
    }

}
